import { render, staticRenderFns } from "./ModalTemplate.vue?vue&type=template&id=7812f1ab"
import script from "./ModalTemplate.vue?vue&type=script&lang=js"
export * from "./ModalTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\laragon\\www\\lifeline-pro\\wp-content\\plugins\\lifeline-donation-pro\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7812f1ab')) {
      api.createRecord('7812f1ab', component.options)
    } else {
      api.reload('7812f1ab', component.options)
    }
    module.hot.accept("./ModalTemplate.vue?vue&type=template&id=7812f1ab", function () {
      api.rerender('7812f1ab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/ModalTemplate.vue"
export default component.exports